export const agenciesPageFallback = {
  pageTitle: "Manage my contacts",
  selfRepresented:
    "You are currently identified as a “Self-represented” Spotlight performer.",
  seekingAgencyLabel: "Are you seeking agency representation?",
  seekingAgencyYes: "Yes, I am happy for agents to contact me.",
  seekingAgencyNo: "No, I am not interested.",
  seekingAgencyYesDescription:
    "By selecting ‘Yes’, your request will be visible to Agents interested in representing new performers. There will be no visible changes to your public profile view.",
  seekingAgencyNoDescription:
    "By selecting ‘No’, there will be no changes to your profile and experience on Spotlight.",
  seekingAgencyHelperCloseButtonAriaLabel: "Close tooltip",
};
